import { ServiceTemplate } from './service-template.model';

/** The editable subset of a template — server/storage owns id and timestamps. */
export type ServiceTemplateInput = Omit<ServiceTemplate, 'id' | 'createdAt' | 'updatedAt'>;

/**
 * Persistence boundary for service templates, used as a DI token. This abstract
 * class has no default provider on purpose: every app that uses the
 * service-templates feature MUST bind an implementation explicitly, e.g. in
 * app.module.ts:
 * `{ provide: ServiceTemplateStorage, useClass: ApiServiceTemplateStorage }`.
 *
 * A missing binding surfaces as a loud "No provider for ServiceTemplateStorage"
 * error rather than silently falling back to a local/in-memory store.
 *
 * The contract is per-item so it maps cleanly onto a REST API: implementations
 * own id and timestamp assignment and return the persisted template.
 */
export abstract class ServiceTemplateStorage {
    abstract getAll(): Promise<ServiceTemplate[]>;
    abstract create(template: ServiceTemplateInput): Promise<ServiceTemplate>;
    abstract update(id: string, template: ServiceTemplateInput): Promise<ServiceTemplate>;
    abstract delete(id: string): Promise<void>;
}
